import { randomString } from '@sceneio/tools'

/**
 * This function is used to create cid
 */
export function createCid(): string {
  return randomString()
}
